import React from "react";

import { Account, GuestAccount } from "fond/types";
import AccountAvatar from "fond/widgets/AccountAvatar";

import { AccountContainer, AccountContent, AccountName, CurrentChip, SwitchingToChip } from "./AccountBox.styles";

type AccountBoxProps = {
  account: Account | GuestAccount;
  isCurrent: boolean;
};

export const AccountBox: React.FC<AccountBoxProps> = ({ account, isCurrent }) => {
  const ChipComponent = isCurrent ? CurrentChip : SwitchingToChip;
  const chipLabel = isCurrent ? "Current" : "Switching to";

  return (
    <AccountContainer isCurrent={isCurrent}>
      <AccountContent>
        <AccountAvatar account={account} variant="rounded" sx={{ width: 30, height: 30 }} />
        <AccountName isCurrent={isCurrent} noWrap>
          {account.Name}
        </AccountName>
      </AccountContent>
      <ChipComponent label={chipLabel} size="small" sx={{ marginLeft: "auto" }} />
    </AccountContainer>
  );
};
